
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-85fbb928&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PasswordRemindVerify.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PasswordRemindVerify.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-85fbb928!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PasswordRemindVerify.vue"),
  /* scopeId */
  "data-v-85fbb928",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/PasswordRemindVerify.vue
// module id = 613
// module chunks = 0